module.exports = __webpack_public_path__ + "static/media/kahf_brand_banner_3.4382aa7d.png";